import createCollectionStore from '../create';
import gql from 'nanographql';
import { getToken } from '../../authentication';
import { getPayload } from '../../json-web-token';
import { BASE_URL, SERVICE_UUID, PERMISSION_GRAPHQL } from '../../config';
import { invokeGraphQL } from '../../graphql';

const LIST_PERMISSIONS = gql`
query listPermissions($principal: UUID!, $provider: String, $service: UUID!) {
  permissions: list(principal: $principal, provider: $provider, service: $service) {
    key
    permissive
  }
}
`;

export default createCollectionStore(
  'Permissions',
  true,
  async () => {
    const token = getToken();
    const payload = getPayload(token);
    const result = await invokeGraphQL(
      PERMISSION_GRAPHQL,
      LIST_PERMISSIONS,
      {
        principal: payload.sub,
        provider: null,
        service: SERVICE_UUID
      }
    );
    return result.permissions;
  },
  'key',
  [],
  {
  }
);



// WEBPACK FOOTER //
// ./src/services/collection/collections/permissions.js